import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21.781 19.687"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.153.001h3.34l-7.3 8.34 8.584 11.347h-6.718L9.8 12.805l-6.028 6.882H.43l7.8-8.921L0 .001h6.892l4.758 6.291Zm-1.171 17.688h1.85L5.886 1.895H3.9Z",
      "data-name": "Icon simple-x"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "share-x"}) } }